'use strict';

var _ = require('lodash');
var JQXGridCellTreatmentService = function JQXGridCellTreatmentService(JQXGridCellTreatmentUserManagementService, JQXGridCellTreatementTrendConstants, app) {
  var SELECTED_CLASS_NAME = 'rm-jqx-grid-cell-selected';
  var SELECTED_CELL_CLASS_NAME = 'rm-jqx-grid-cell-selected-rectangle';
  var MODIFIED_CLASS_NAME = 'rm-jqx-grid-cell-modified';
  var DISABLED_CLASS_NAME = 'rm-jqx-grid-cell-disabled';
  var WARNING_CLASS_NAME = 'rm-jqx-grid-cell-warning-icon';
  var USER_COLUMN_CLASS_NAME = 'rm-jqx-grid-cell-user-column';
  var SCENARIO_SPECIFIC_RECORD_CLASS_NAME = 'rm-scenario-specific-record';
  var ALERT_ROW_CLASS = 'rm-jqx-grid-cell-alert-score';
  var ALERT_ROW_CRITICAL_CLASS = 'rm-jqx-grid-cell-alert-score-critical';
  var ALERT_CELL_CLASS = 'rm-jqx-grid-cell-alert-score-number';
  var CHECKBOX_CELL_CLASS = 'rm-jqx-grid-cell-system-checkbox';
  var UPDATED_LAST_PROCESSED_CLASS = 'rm-updated-last-processed-cell';
  var REFRESHED_UP_CLASS = 'rm-jqx-grid-cell-trend-up';
  var REFRESHED_DOWN_CLASS = 'rm-jqx-grid-cell-trend-down';
  var BOOKING_INTAKE_RED = 'rm-jqx-grid-cell-booking-intake-red';
  var BOOKING_INTAKE_NEUTRAL = 'rm-jqx-grid-cell-booking-intake-neutral';
  var BOOKING_INTAKE_GREEN = 'rm-jqx-grid-cell-booking-intake-green';
  var BOOKING_INTAKE_PERFORMANCE_TOTAL = 'bookingIntakePerformanceTotal';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS = 'bookingIntakePerformanceGroupBookings';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR = 'bookingIntakePerformanceLoadFactor';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN = 'bookingIntakePerformanceLowestClassOpen';
  var BOOKING_INTAKE_PERFORMANCE_TOTAL_LY = 'bookingIntakePerfTotalBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY = 'bookingIntakePerfGroupBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY = 'bookingIntakePerfLoadFactorLY';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY = 'bookingIntakePerfLowestClassOpenLY';
  var BOOKING_INTAKE_PERFORMANCE_MAP = {};
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_TOTAL] = BOOKING_INTAKE_PERFORMANCE_TOTAL_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS] = BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR] = BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY;
  BOOKING_INTAKE_PERFORMANCE_MAP[BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN] = BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY;
  var BOOKING_INTAKE_FIELDS = [BOOKING_INTAKE_PERFORMANCE_TOTAL, BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS, BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR, BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN];
  var trendProperties = Array.prototype.concat(JQXGridCellTreatementTrendConstants.FLIGHT_PROPERTIES, JQXGridCellTreatementTrendConstants.MARKET_PROPERTIES);
  var timestampProperties = _.reduce(JQXGridCellTreatementTrendConstants.TIMESTAMP_PROPERTIES, pickTimestampProperty, {});
  var refreshProperties = _.chain(trendProperties).concat(JQXGridCellTreatementTrendConstants.LIVE_DATA_PROPERTIES).reduce(pickProperty, {}).value();
  function pickTimestampProperty(result, prop) {
    result[prop] = true;
    return result;
  }
  function pickProperty(result, prop) {
    if (!timestampProperties[prop]) {
      result[prop] = true;
    }
    return result;
  }

  // Adds SELECTED_CLASS_NAME when row is selected
  function addSelectedClass(classNames, selectedrowindexes, rowId) {
    if (_.indexOf(selectedrowindexes, rowId) !== -1) {
      classNames.push(SELECTED_CLASS_NAME);
    }
  }

  // Adds SELECTED_CELL_CLASS_NAME for rectangle selection with shift click
  function addSelectedCellClass(classNames, selectedCells, rowId, datafield) {
    if (selectedCells && !!selectedCells[rowId + '_' + datafield]) {
      classNames.push(SELECTED_CELL_CLASS_NAME);
    }
  }

  // Adds MODIFIED_CLASS_NAME when cell has been modified
  function addModifiedClass(classNames, rowData, disabled, datafield, value) {
    var old = rowData && rowData._old;
    if (old) {
      if (old.hasOwnProperty(datafield) && old[datafield] !== value) {
        classNames.push(MODIFIED_CLASS_NAME);
      }
    }
    if (disabled) {
      classNames.push(DISABLED_CLASS_NAME);
      if (rowData && rowData.parentsRequired) {
        classNames.push(WARNING_CLASS_NAME);
      }
    }
  }

  // Adds custom class specified for datafield
  function addCustomClass(classNames, rowData, datafield) {
    if (rowData && rowData.customClasses) {
      var customClass = rowData.customClasses[datafield];
      if (customClass !== undefined) {
        classNames.push('rm-jqx-grid-cell-' + customClass);
      }
    }
  }
  function addAlertClasses(classNames, rowData, datafield) {
    if (rowData && (rowData.alerts || rowData.alertScore)) {
      if (rowData.alerts) {
        classNames.push(rowData.alertThresholdExceeded ? ALERT_ROW_CRITICAL_CLASS : ALERT_ROW_CLASS);
      }
      if (datafield === 'alerts' || datafield === 'alertScore' || datafield === 'topAlert') {
        classNames.push(ALERT_CELL_CLASS);
      }
    }
  }
  function addCheckboxClass(classNames, datafield) {
    if (datafield === '_checkboxcolumn') {
      classNames.push(CHECKBOX_CELL_CLASS);
    }
  }
  function addUserScenarioClass(classNames, rowData) {
    if (rowData && rowData.userScenarioModified) {
      classNames.push(SCENARIO_SPECIFIC_RECORD_CLASS_NAME);
    }
  }
  function addLastProcessedClass(classNames, datafield, value, dataBeforeRefresh, rowData) {
    if (timestampProperties[datafield]) {
      var valueBeforeRefresh = dataBeforeRefresh[rowData.entryKey][datafield];
      if (!valueBeforeRefresh.isSame(value)) {
        classNames.push(UPDATED_LAST_PROCESSED_CLASS);
      }
    }
  }
  function addOnRefreshChangedValuesClasses(classNames, datafield, value, dataBeforeRefresh, rowData) {
    if (refreshProperties[datafield]) {
      var valueBeforeRefresh = dataBeforeRefresh[rowData.entryKey][datafield];
      if (value > valueBeforeRefresh) {
        classNames.push(REFRESHED_UP_CLASS);
      } else if (value < valueBeforeRefresh) {
        classNames.push(REFRESHED_DOWN_CLASS);
      }
    }
  }
  function addRefreshedClasses(classNames, rowData, datafield, value, dataBeforeRefresh) {
    if (dataBeforeRefresh && dataBeforeRefresh[rowData.entryKey]) {
      addLastProcessedClass(classNames, datafield, value, dataBeforeRefresh, rowData);
      addOnRefreshChangedValuesClasses(classNames, datafield, value, dataBeforeRefresh, rowData);
    }
  }
  function addUserFieldClasses(classNames, isUserColumn) {
    if (isUserColumn) {
      classNames.push(USER_COLUMN_CLASS_NAME);
    }
  }
  function getClassIndex(clazz, defaultClassIndexes, marketClassIndexes) {
    if (_.isEmpty(clazz)) {
      return;
    }
    if (!marketClassIndexes) {
      return defaultClassIndexes[clazz] * -1;
    }
    return marketClassIndexes[clazz] * -1;
  }
  function flightSummaryBookingIntakeClasses(classNames, datafield, value, rowData) {
    var fieldName = _.find(BOOKING_INTAKE_FIELDS, function (fieldname) {
      return _.includes(datafield, fieldname);
    });
    if (!fieldName) {
      return;
    }
    var isLowestClassField = fieldName === BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN;
    var defaultClassIndex = app.classesIndexesMapping["default"];
    var classIndexes = app.classesIndexesMapping[rowData.leg];
    var offset = _.chain(datafield).clone().thru(function (datafield) {
      return _.replace(datafield, fieldName, '');
    }).value();
    var lyValue = isLowestClassField ? getClassIndex(rowData[BOOKING_INTAKE_PERFORMANCE_MAP[fieldName] + offset], defaultClassIndex, classIndexes) : rowData[BOOKING_INTAKE_PERFORMANCE_MAP[fieldName] + offset];
    var curValue = isLowestClassField ? getClassIndex(value, defaultClassIndex, classIndexes) : value;
    if (_.isUndefined(lyValue)) {
      classNames.push(BOOKING_INTAKE_NEUTRAL);
    } else if (curValue > lyValue) {
      classNames.push(BOOKING_INTAKE_GREEN);
    } else if (curValue < lyValue) {
      classNames.push(BOOKING_INTAKE_RED);
    } else {
      classNames.push(BOOKING_INTAKE_NEUTRAL);
    }
  }
  function getCellClasses(rowId, rowData, selectedrowindexes, datafield, value, disabled, dataBeforeRefresh, columnsProperties, selectedCells) {
    var classNames = [];
    addSelectedClass(classNames, selectedrowindexes, rowId);
    addSelectedCellClass(classNames, selectedCells, rowId, datafield);
    addModifiedClass(classNames, rowData, disabled, datafield, value);
    addCustomClass(classNames, rowData, datafield);
    addAlertClasses(classNames, rowData, datafield);
    addCheckboxClass(classNames, datafield);
    addUserScenarioClass(classNames, rowData);
    addRefreshedClasses(classNames, rowData, datafield, value, dataBeforeRefresh);
    addUserFieldClasses(classNames, _.get(columnsProperties, 'isUserColumn', false));
    flightSummaryBookingIntakeClasses(classNames, datafield, value, rowData);
    classNames = _.concat(classNames, JQXGridCellTreatmentUserManagementService.getClasses.apply(null, arguments));
    return _.uniq(classNames).join(' ');
  }
  function getRefreshCellNames() {
    return refreshProperties;
  }
  return {
    getCellClasses: getCellClasses,
    getRefreshCellNames: getRefreshCellNames
  };
};
JQXGridCellTreatmentService.$inject = ['JQXGridCellTreatmentUserManagementService', 'JQXGridCellTreatementTrendConstants', 'App'];
module.exports = JQXGridCellTreatmentService;